angular.module('impactx.catalog').controller('CatalogTypeSelectionCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    '$redirect',
    'internalCatLabel',
    'externalCatLabel',
    'confirmLabel',
    'abortLabel',
    'actionLabel',
    'uploadCatLabel',
    '$securityManager',
    CatalogTypeSelectionCtrl]);

function CatalogTypeSelectionCtrl($scope, $mdDialog, themeFactory, $redirect, internalCatLabel, externalCatLabel,
                                  confirmLabel, abortLabel, actionLabel, uploadCatLabel, $securityManager)
{
    $scope.selectedType = {};
    $scope.selectedType.value = 1;
    $scope.internalCatLabel = internalCatLabel;
    $scope.externalCatLabel = externalCatLabel;
    $scope.confirmLabel = confirmLabel;
    $scope.abortLabel = abortLabel;
    $scope.actionLabel = actionLabel;
    $scope.uploadCatLabel = uploadCatLabel;
    $scope.hasRightToUpload = $securityManager.isProcessAllowed("SupplierCatalogUpload");
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        $mdDialog.hide();
        if ($scope.selectedType.value == 1)
        {
            $redirect.redirectTo( null,"/internalcatalog/0");
        }
        else if ($scope.selectedType.value == 2)
        {
            $redirect.redirectTo( null,"/externalcatalog/0");
        }
        else
        {
            $redirect.redirectTo( null,"/suppliercatalogupload");
        }
    };
}